import { Button, Dropdown, Input, Menu } from "antd";
import React, { useEffect, useState } from "react";
import ascendingIcon from "../../../assets/icon/ascendingIcon.svg";
import descendingIcon from "../../../assets/icon/descendingIcon.svg";
import filterIcon from "../../../assets/icon/filterIcon.svg";
import searchIcon from "../../../assets/icon/searchIcon.svg";
import { HelperContext } from "../../../store/helperStore";
import GetTestCard from "./getTestCard";
import { sortTestData } from "./testSorting";

export default function Filters({
  testType,
  filterR,
  filterNonAudio,
  dispatchFilter,
  dispatchFilterNonAudio,
  getAttemptFlag,
}) {
  const isAttemptedMenu = (testType) => {
    return (
      <Menu>
        <Menu.Item
          onClick={() => {
            getAttemptFlag(null);
            testType === "audio"
              ? dispatchFilter({ type: "RESET" })
              : dispatchFilterNonAudio({ type: "RESET" });
          }}
        >
          <span>All</span>
        </Menu.Item>
        <Menu.Item
          onClick={() => {
            getAttemptFlag("1");
            testType === "audio"
              ? dispatchFilter({ type: "RESET" })
              : dispatchFilterNonAudio({ type: "RESET" });
          }}
        >
          <span>Attempted</span>
        </Menu.Item>
        <Menu.Item
          onClick={() => {
            getAttemptFlag("0");
            testType === "audio"
              ? dispatchFilter({ type: "RESET" })
              : dispatchFilterNonAudio({ type: "RESET" });
          }}
        >
          <span>Unattempted</span>
        </Menu.Item>
      </Menu>
    );
  };

  const sortByMenu = (testType) => {
    return (
      <Menu>
        <Menu.Item
          onClick={() => {
            testType === "audio"
              ? dispatchFilter({ type: "name" })
              : dispatchFilterNonAudio({ type: "name" });
          }}
        >
          <span>Name</span>
        </Menu.Item>
        <Menu.Item
          onClick={() => {
            testType === "audio"
              ? dispatchFilter({ type: "latest" })
              : dispatchFilterNonAudio({ type: "latest" });
          }}
        >
          <span>Latest</span>
        </Menu.Item>
        <Menu.Item
          onClick={() => {
            testType === "audio"
              ? dispatchFilter({ type: "totalTime" })
              : dispatchFilterNonAudio({ type: "totalTime" });
          }}
        >
          <span>Total Time</span>
        </Menu.Item>
      </Menu>
    );
  };

  return (
    <div className="test-filter">
      <Input
        prefix={<img src={searchIcon} alt="" />}
        placeholder="search"
        value={testType === "audio" ? filterR.search : filterNonAudio.search}
        onChange={(e) =>
          testType === "audio"
            ? dispatchFilter({
                type: "SEARCH",
                payload: e.target.value,
              })
            : dispatchFilterNonAudio({
                type: "SEARCH",
                payload: e.target.value,
              })
        }
      ></Input>
      <div className="select-filter">
        <div className="sort-btn">
          <Dropdown overlay={sortByMenu(testType)}>
            <div className="test-sort-by">Sort By</div>
          </Dropdown>
          <div
            className="test-not-reverse"
            onClick={() => {
              testType === "audio"
                ? dispatchFilter({
                    type: "reverse",
                  })
                : dispatchFilterNonAudio({
                    type: "reverse",
                  });
            }}
          >
            {testType === "audio" && (
              <img
                src={filterR.reverse ? ascendingIcon : descendingIcon}
                alt=""
              />
            )}
            {testType !== "audio" && (
              <img
                src={filterNonAudio.reverse ? ascendingIcon : descendingIcon}
                alt=""
              />
            )}
          </div>
        </div>
        <Dropdown overlay={isAttemptedMenu(testType)}>
          <Button className="test-attempt">
            <img src={filterIcon} alt="" className="" />
          </Button>
        </Dropdown>
      </div>
    </div>
  );
}

export const GetNonAudioFilteredTest = ({ filterNonAudio, nonAudioTest }) => {
  const [instVisible, setInstVisible] = useState();
  const { helperC, dispatchHelper } = HelperContext();

  useEffect(() => {
    if (helperC.testType === "DEMO") {
      setInstVisible(true);
    }
  }, []);

  const { name, latest, totalTime } = filterNonAudio;
  let nonAudioData = nonAudioTest.data;
  if (!!name) {
    nonAudioData = sortTestData(nonAudioData, "name");
  }
  if (!!latest) {
    nonAudioData = sortTestData(nonAudioData, "latest");
  }
  if (!!totalTime) {
    nonAudioData = sortTestData(nonAudioData, "totalTime");
  }
  if (!!filterNonAudio.reverse) {
    nonAudioData = nonAudioData.reverse();
  }
  nonAudioData = nonAudioData.filter(function (myNonAudioData) {
    return myNonAudioData.test_name
      .toLowerCase()
      .includes(filterNonAudio.search.toLowerCase());
  });
  return (
    <GetTestCard
      instVisible={instVisible}
      handleInstVisible={(data) => {
        setInstVisible(data);
      }}
      testData={nonAudioData}
      type="nonAudio"
    />
  );
};

export const GetAudioFilteredTest = ({ filterR, audioTest }) => {
  const [instVisible, setInstVisible] = useState(false);
  const { helperC, dispatchHelper } = HelperContext();

  useEffect(() => {
    if (helperC.testType === "DEMO") {
      setInstVisible(true);
    }
  }, []);

  const { name, latest, totalTime } = filterR;
  let audioData = audioTest.data;
  if (!!name) {
    audioData = sortTestData(audioData, "name");
  }
  if (!!latest) {
    audioData = sortTestData(audioData, "latest");
  }
  if (!!totalTime) {
    audioData = sortTestData(audioData, "totalTime");
  }
  if (!!filterR.reverse) {
    audioData = audioData.reverse();
  }
  audioData = audioData.filter(function (audioData) {
    return (
      audioData &&
      audioData.test_name.toLowerCase().includes(filterR.search.toLowerCase())
    );
  });

  return (
    <GetTestCard
      instVisible={instVisible}
      handleInstVisible={(data) => {
        setInstVisible(data);
      }}
      testData={audioData}
      type="audio"
    />
  );
};
